export default __webpack_public_path__ + "static/media/LSBU.ac825d0c.png";